var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.125 36.5V52.4688C9.125 53.6788 9.60569 54.8393 10.4613 55.6949C11.317 56.5506 12.4774 57.0312 13.6875 57.0312H18.25C19.4601 57.0312 20.6205 56.5506 21.4762 55.6949C22.3318 54.8393 22.8125 53.6788 22.8125 52.4688V41.0625C22.8125 39.8524 22.3318 38.692 21.4762 37.8363C20.6205 36.9807 19.4601 36.5 18.25 36.5H9.125Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.2901 36.5H55.1651C53.9551 36.5 52.7946 36.9807 51.939 37.8363C51.0833 38.692 50.6026 39.8524 50.6026 41.0625V52.4688C50.6026 53.6788 51.0833 54.8393 51.939 55.6949C52.7946 56.5506 53.9551 57.0312 55.1651 57.0312H59.7276C60.9377 57.0312 62.0982 56.5506 62.9538 55.6949C63.8094 54.8393 64.2901 53.6788 64.2901 52.4688V36.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2901 36.5H55.1651C53.9551 36.5 52.7946 36.9807 51.939 37.8363C51.0833 38.692 50.6026 39.8525 50.6026 41.0625V52.4688C50.6026 53.6788 51.0833 54.8393 51.939 55.6949C52.7946 56.5506 53.9551 57.0313 55.1651 57.0313H59.7276C60.9377 57.0313 62.0982 56.5506 62.9538 55.6949C63.8094 54.8393 64.2901 53.6788 64.2901 52.4688V36.5ZM64.2901 36.5C64.2901 32.8876 63.5752 29.3109 62.1864 25.9761C60.7977 22.6413 58.7627 19.6144 56.1987 17.0697C53.6346 14.5251 50.5923 12.513 47.2471 11.1496C43.9019 9.78623 40.3199 9.0984 36.7076 9.12579C33.0953 9.0984 29.5133 9.78623 26.168 11.1496C22.8228 12.513 19.7805 14.5251 17.2165 17.0697C14.6525 19.6144 12.6174 22.6413 11.2287 25.9761C9.83997 29.3109 9.125 32.8876 9.125 36.5V52.4688C9.125 53.6788 9.60569 54.8393 10.4613 55.6949C11.317 56.5506 12.4774 57.0313 13.6875 57.0313H18.25C19.4601 57.0313 20.6205 56.5506 21.4762 55.6949C22.3318 54.8393 22.8125 53.6788 22.8125 52.4688V41.0625C22.8125 39.8525 22.3318 38.692 21.4762 37.8363C20.6205 36.9807 19.4601 36.5 18.25 36.5H9.125",
    stroke: "black",
    strokeWidth: 4.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2901 52.4688V59.3125C64.2901 61.7326 63.3288 64.0536 61.6175 65.7648C59.9062 67.4761 57.5852 68.4375 55.1651 68.4375H38.7812",
    stroke: "black",
    strokeWidth: 4.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.3b6da82b9e67cb746d3e6d74a536f86e.svg";
export { ForwardRef as ReactComponent };